import { genId } from '@/utils/id'
import { seedDecisions } from '@/mock/seed'

export default {
  namespaced: true,
  state: {
    list: seedDecisions
  },
  getters: {
    byTrip: state => tripId => state.list.filter(d => d.tripId === tripId),
    byId: state => id => state.list.find(d => d.id === id)
  },
  mutations: {
    ADD_DECISION (state, decision) {
      state.list.unshift(decision)
    },
    UPDATE_DECISION (state, { id, patch }) {
      const d = state.list.find(x => x.id === id)
      if (d) Object.assign(d, patch)
    }
  },
  actions: {
    createDecision ({ commit }, { tripId, question, options, multi, deadline, hideResultsUntilVoted, createdBy }) {
      const id = genId()
      commit('ADD_DECISION', {
        id,
        tripId,
        question,
        multi: !!multi,
        options: options.map(o => ({ id: genId(), label: o.label, pointId: o.pointId || null })),
        deadline: deadline || null,
        hideResultsUntilVoted: !!hideResultsUntilVoted,
        status: 'open',
        resultOptionId: null,
        createdBy,
        votes: []
      })
      return id
    },
    castVote ({ commit, state }, { decisionId, memberId, optionIds, reason }) {
      const decision = state.list.find(d => d.id === decisionId)
      if (!decision) return
      const votes = decision.votes.filter(v => v.memberId !== memberId)
      votes.push({ memberId, optionIds, reason: reason || '' })
      commit('UPDATE_DECISION', { id: decisionId, patch: { votes } })
    },
    decide ({ commit }, { decisionId, resultOptionId }) {
      commit('UPDATE_DECISION', { id: decisionId, patch: { status: 'decided', resultOptionId } })
    },
    closeVoting ({ commit }, decisionId) {
      commit('UPDATE_DECISION', { id: decisionId, patch: { status: 'closed' } })
    }
  }
}
